import script from "./SwiperImages.vue?vue&type=script&setup=true&lang=js"
export * from "./SwiperImages.vue?vue&type=script&setup=true&lang=js"

import "./SwiperImages.vue?vue&type=style&index=0&id=4aa747e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aa747e0"]])

export default __exports__